export default "__VITE_ASSET__DbrgnWHe__"